"use client";

import {getShelfId} from "../../../../../_components/CourseShelf";
import ScrollingLinkButton from "../../../../../_components/ScrollingLinkButton";
import {ButtonVariant} from "../../../../../_components/Button";
import {CatalogSection} from "../catalogTypes";
import * as _ from "lodash-es";
import {FCWithHTMLAttributes} from "@/app/types/reactTypes";
import AbstractBannerButtonFrame from "@/app/_components/AbstractBannerButtonFrame";

interface CatalogSubjectButtonsProps {
	catalogSections: CatalogSection[];
}

const CatalogSubjectButtons: FCWithHTMLAttributes<
	CatalogSubjectButtonsProps
> = ({catalogSections, className}) => {
	const uniqueSubjects = _.uniqBy(
		catalogSections.map((section) => section.subject.data.attributes),
		"subjectId"
	);
	return (
		<AbstractBannerButtonFrame className={className}>
			{uniqueSubjects.map(({subjectId, subjectName}) => {
				const shelfId = getShelfId(subjectId);
				return (
					<ScrollingLinkButton
						variant={ButtonVariant.FILTER_ROUND}
						key={subjectId}
						href={`#${shelfId}`}
						targetId={shelfId}
					>
						{subjectName}
					</ScrollingLinkButton>
				);
			})}
		</AbstractBannerButtonFrame>
	);
};

export default CatalogSubjectButtons;
